import {createSelector} from 'reselect';

import {CustomerType, HostApplicationStoreType} from 'hostApplicationStoreType';

/**
 * returns data about customer from host
 */
export const getCustomer = (store: HostApplicationStoreType) => store.customer;

/**
 * Get currency
 * @param {HostApplicationStoreType} state - Application state
 * @returns CustomerType['currency'] - currency
 */
export const getCurrency = createSelector(
    getCustomer,
    (customer: CustomerType): CustomerType['currency'] => customer.currency,
);

/**
 * Returns if user logged in
 * @param {HostApplicationStoreType} store - store
 */
export const getIsCustomerLogged = (store: HostApplicationStoreType) => store.customer.is_logged_in;

/**
 * Get the email of an authorized user
 * @param {HostApplicationStoreType} store - current store
 * @return {string} email of customer
 */
export const getAuthCustomerEmail = createSelector(
    getCustomer,
    (customer: CustomerType): string => customer.email,
);

/**
 * Get customer form key
 * @param {HostApplicationStoreType} store - application store
 * @returns {string} - form key
 */
export const getCustomerFormKey = createSelector(
    getCustomer,
    (customer: CustomerType): string => customer.form_key,
);
